import { CAMERA_ORIGINAL_PREFIX } from './device-data.constants';

export const isCameraOriginal = (fileName: string): boolean =>
  fileName.startsWith(CAMERA_ORIGINAL_PREFIX);
